export default {
  list: [
    { title: { en: 'Male', fa: 'آقا' }, value: 1 },
    { title: { en: 'Female', fa: 'خانم' }, value: 2 },
  ],
};
